var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "welcome-dialog",
          staticStyle: { "'margin-top": "50vh" },
          attrs: {
            title: "选择欢迎语",
            visible: _vm.show,
            "append-to-body": "",
            width: "550px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.show = $event
            },
            close: function($event) {
              return _vm.cancelHandle()
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { padding: "10px 0" } },
            [
              _c(
                "el-input",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    placeholder: "输入关键词",
                    size: "small",
                    clearable: ""
                  },
                  on: { blur: _vm.searchHandle, clear: _vm.searchHandle },
                  model: {
                    value: _vm.keywords,
                    callback: function($$v) {
                      _vm.keywords = $$v
                    },
                    expression: "keywords"
                  }
                },
                [
                  _c("el-button", {
                    attrs: { slot: "append", icon: "el-icon-search" },
                    on: {
                      click: function($event) {
                        return _vm.searchHandle()
                      }
                    },
                    slot: "append"
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "ul",
            { staticClass: "welcome-list" },
            _vm._l(_vm.welcomeList, function(item, index) {
              return _c(
                "li",
                {
                  key: item.welcomeId,
                  staticClass: "welcome-item",
                  class: { "welcome-select": item.isSelect },
                  on: {
                    click: function($event) {
                      return _vm.selectWelcome(index, item)
                    }
                  }
                },
                [_vm._v(" " + _vm._s(item.welcomeContent) + " ")]
              )
            }),
            0
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      return _vm.cancelHandle()
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function($event) {
                      return _vm.confirmHandle()
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }